import React from 'react'
import { Loader } from './Loader.styled'

const Loading = ({ children }) => {
  return <Loader>{children}</Loader>
}

export default Loading
